import React from "react";
import ToggleView from "./toggle_game_admin";
import AboutPage from './AboutPage';
import Rules from './Rules';



function App() {
  return (
    <div className="App">
      <ToggleView />
    </div>
  );
}

export default App;



